import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 企业微信相关数据
    wechat: {
      isInitialized: false,
      corpId: '',
      agentId: '',
      code: '',
      userId: '',
      userInfo: {},
      sdkVersion: '',
      debugInfo: {
        requests: [],
        errors: [],
        environment: {},
        signatures: {},
        sdkRegistration: {},
        getUserIdApi: {},
        logs: []
      }
    }
  },
  getters: {
    // 企业微信相关getters
    isWechatReady: state => {
      // 检查是否初始化完成
      const isInitialized = state.wechat.isInitialized;
      // 检查是否获取到用户ID（服务端用户ID或前端用户ID）
      const hasServerUserId = state.wechat.debugInfo?.getUserIdApi?.response;
      const hasFrontendUserId = state.wechat.userInfo?.frontend?.userId || state.wechat.userInfo?.externalUserId;
      const hasUserId = hasServerUserId || hasFrontendUserId;

      // 只有当初始化完成且获取到用户ID时才认为准备就绪
      return isInitialized && hasUserId;
    },
    wechatCorpId: state => state.wechat.corpId,
    wechatUserId: state => state.wechat.debugInfo?.getUserIdApi?.response || state.wechat.userId,
    wechatUserInfo: state => state.wechat.userInfo,
    wechatDebugInfo: state => state.wechat.debugInfo
  },
  mutations: {
    // 设置企业微信初始化状态
    SET_WECHAT_INITIALIZED(state, status) {
      state.wechat.isInitialized = status
    },
    // 设置企业微信基本信息
    SET_WECHAT_BASIC_INFO(state, { corpId, agentId, sdkVersion, code }) {
      state.wechat.corpId = corpId
      state.wechat.agentId = agentId
      state.wechat.sdkVersion = sdkVersion
      state.wechat.code = code || ''
    },
    // 设置用户信息
    SET_WECHAT_USER_INFO(state, { userId, userInfo }) {
      state.wechat.userId = userId
      state.wechat.userInfo = userInfo
    },
    // 添加调试信息
    ADD_WECHAT_DEBUG_INFO(state, debugInfo) {
      state.wechat.debugInfo.requests.push(debugInfo)
    },
    // 添加错误信息
    ADD_WECHAT_ERROR(state, error) {
      state.wechat.debugInfo.errors.push({
        time: new Date().toLocaleTimeString(),
        error: error
      })
    },
    // 设置环境信息
    SET_WECHAT_ENVIRONMENT(state, envInfo) {
      state.wechat.debugInfo.environment = envInfo
    },
    // 设置签名调试信息
    SET_WECHAT_SIGNATURE_DEBUG(state, sigInfo) {
      state.wechat.debugInfo.signatures = sigInfo
    },
    // 设置SDK注册调试信息
    SET_WECHAT_SDK_DEBUG(state, sdkInfo) {
      state.wechat.debugInfo.sdkRegistration = sdkInfo
    },
    // 设置getUserId接口调试信息
    SET_WECHAT_GETUSERID_DEBUG(state, apiInfo) {
      state.wechat.debugInfo.getUserIdApi = apiInfo
    },
    // 添加调试日志
    ADD_WECHAT_LOG(state, log) {
      state.wechat.debugInfo.logs.push({
        time: new Date().toLocaleTimeString(),
        level: log.level || 'info',
        message: log.message,
        data: log.data
      })
      // 保持最新的50条日志
      if (state.wechat.debugInfo.logs.length > 50) {
        state.wechat.debugInfo.logs.shift()
      }
    }
  },
  actions: {
    // 初始化企业微信
    async initWechat({ commit }, { corpId, code, agentId }) {
      try {
        commit('SET_WECHAT_INITIALIZED', false)

        // 根据corpId确定agentId
        const calculatedAgentId = agentId || (corpId == "wwa731f1a5d453f22f" ? "1000007" : "1000010");

        // 这里会在App.vue中调用具体的API
        const basicInfo = {
          corpId: corpId || 'wwa731f1a5d453f22f',
          agentId: calculatedAgentId,
          sdkVersion: '',
          code: code || '' // 使用code参数
        }

        commit('SET_WECHAT_BASIC_INFO', basicInfo)
        return basicInfo
      } catch (error) {
        commit('ADD_WECHAT_ERROR', error.message)
        throw error
      }
    },

    // 设置用户信息  
    setWechatUserInfo({ commit }, userInfo) {
      commit('SET_WECHAT_USER_INFO', userInfo)
    },

    // 完成初始化
    completeWechatInit({ commit }) {
      commit('SET_WECHAT_INITIALIZED', true)
    }
  },
  modules: {
  }
})
